import { Trash2, Download, Eye } from 'lucide-react';
import { SliderData } from '../../types/slider';
import { Button } from '../base/Button';

interface HistoryItemProps {
  slider: SliderData;
  onPreview: (slider: SliderData) => void;
  onDelete: (id: string) => void;
  onDownload: (slider: SliderData) => void;
}

export const HistoryItem = ({ slider, onPreview, onDelete, onDownload }: HistoryItemProps) => {
  const formatDate = (timestamp: number) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow duration-200">
      <div className="flex gap-4">
        <div className="flex-shrink-0 w-24 h-24 bg-gray-100 rounded-lg overflow-hidden">
          <img 
            src={slider.beforeImage} 
            alt="Thumbnail" 
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-gray-900 truncate mb-1">
            {slider.title || 'スライダー'}
          </h4>
          <p className="text-xs text-gray-500 mb-3">
            {formatDate(slider.createdAt)}
          </p>
          
          <div className="flex flex-wrap gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onPreview(slider)}
              icon={<Eye className="w-4 h-4" />}
            >
              プレビュー
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDownload(slider)}
              icon={<Download className="w-4 h-4" />}
            >
              ダウンロード
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDelete(slider.id)}
              icon={<Trash2 className="w-4 h-4" />}
              className="text-red-600 hover:bg-red-50"
            >
              削除
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
